import { Breed } from '@loom-api-types'

export const BREED_LABELS = {
  [Breed.All]: 'All breeds',
  [Breed.Merino]: 'Merino',
  [Breed.MidMicron]: 'Mid Micron',
  [Breed.QuarterBred]: 'Quarterbred',
  [Breed.Unclassified]: 'Unclassified',
  [Breed.Xbd]: 'Crossbred',
}

export const SPECI_BREED_LABELS = [
  'Merino',
  'Dohne',
  'Polwarth',
  'Quarterbred',
  'Halfbred',
  'Corriedale',
  'Crossbred',
  'Romney',
  'Perendale',
  'Coopworth',
  'Composite',
  'Black face',
]
